
import React from "react";
import {
  CardTitle,
  CardDescription,
} from "@/components/ui/card";

interface ReportSummaryHeaderProps {
  title: string;
  description: string;
  totalAmount: number;
  additionalInfo?: React.ReactNode;
}

const ReportSummaryHeader = ({
  title,
  description,
  totalAmount,
  additionalInfo,
}: ReportSummaryHeaderProps) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
      <div>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </div>
      <div className="flex flex-col items-end mt-4 md:mt-0">
        <div className="text-2xl font-bold">
          ${totalAmount.toLocaleString()}
        </div>
        {additionalInfo}
      </div>
    </div>
  );
};

export default ReportSummaryHeader;
